"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "barbarano-mossano": {
    "574ea051": [{
      "hkey": "72ff7d1d",
      "slug": "barbarano-mossano",
      "name": "Barbarano Mossano",
      "primary": true,
      "skipSearch": false
    }],
    "mezzana": [{
      "hkey": "72ff7d1d",
      "slug": "barbarano-mossano",
      "name": "Barbarano Mossano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b2024e5c": [{
      "hkey": "4affd5c3",
      "slug": "ponte-di-barbarano",
      "name": "Ponte di Barbarano",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-barbarano": [{
      "hkey": "4affd5c3",
      "slug": "ponte-di-barbarano",
      "name": "Ponte di Barbarano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "28af95a7": [{
      "hkey": "c54739f4",
      "slug": "san-giovanni-in-monte",
      "name": "San Giovanni in Monte",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "c54739f4",
      "slug": "san-giovanni-in-monte",
      "name": "San Giovanni in Monte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "barbarano-mossano"
    }],
    "2c7fc3f1": [{
      "hkey": "72ff7d1d",
      "slug": "barbarano-mossano",
      "name": "Barbarano Mossano",
      "primary": true,
      "skipSearch": false
    }],
    "san-pancrazio": [{
      "hkey": "72ff7d1d",
      "slug": "barbarano-mossano",
      "name": "Barbarano Mossano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;